<form *ngIf="form" [formGroup]="form" class="p-3 border rounded">
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('paymentTypeDebtor')"
                [config]="formConfiguration.paymentTypeDebtor">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('debtorPartnersId')" [config]="formConfiguration.debtorPartnersId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('paymentDebtorUid')" [config]="formConfiguration.paymentDebtorUid">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('debtorEfectivoId')" [config]="formConfiguration.debtorEfectivoId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('expenseAccountDebtor')"
                [config]="formConfiguration.expenseAccountDebtor">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('accountNumberDebtor')"
                [config]="formConfiguration.accountNumberDebtor"></app-input>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('taxDebtorUid')" [config]="formConfiguration.taxDebtorUid">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('taxDebtorSecondUid')"
                [config]="formConfiguration.taxDebtorSecondUid">
            </app-select>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('expirationDebtor')"
                [config]="formConfiguration.expirationDebtor"></app-input>
        </div>
    </div>
</form>